import AuthState from '@/models/auth/auth-state.model';

export const state: AuthState = new AuthState();
